import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                trigger: 'toggle'
            }
        }
    }

    init() {
        this.isOpen = false;
        this.outsideClickBind = (e) => {
            if (!this.el.contains(e.target)) {
                this.close();
            }
        };
    }

    toggle() {
        this.isOpen ? this.close() : this.open();
    }

    open() {
        this.isOpen = true;
        this.$('trigger')[0].setAttribute('aria-expanded', 'true');
        this.$('dropdown')[0].removeAttribute('hidden');
        setTimeout(() => {
            document.addEventListener('click', this.outsideClickBind);
        }, 0);
    }

    close() {
        this.isOpen = false;
        this.$('trigger')[0].setAttribute('aria-expanded', 'false');
        this.$('dropdown')[0].setAttribute('hidden', '');
        document.removeEventListener('click', this.outsideClickBind);
    }

    destroy() {
        document.removeEventListener('click', this.outsideClickBind);
    }
}
